import React, { Component } from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';

import SweetAlert from 'sweetalert-react';
import { Redirect } from 'react-router-dom';
import { storageKeys, userKeys } from 'config/settings.json';
import { sessionManager } from 'hooks/useSessionManager/sessionManager';
import Email from 'components/LoginForm/Email';
import Forgot from 'components/LoginForm/Forgot';
import MagicLink from 'components/MagicLink';
import APIHandler from 'config/APIHandler';
import StorageHandler from 'config/StorageHandler';
import { Register } from 'components/LoginForm/Register/Register';
import { getLastEmail, setLastEmail } from 'helpers/loginEmailStore';

import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const checkInputValidityFields = () => {
  const inputs = document.getElementsByTagName('input');
  const inputArray = [];
  const selects = document.getElementsByTagName('select');
  const selectArray = Array.from(selects);

  Array.from(inputs).forEach((input) => {
    inputArray.push(input);
  });

  const emptyFields = [];
  Array.from(inputs).forEach((input) => {
    if (input.checkValidity() === false) {
      let name = input.name.replace(/reg_/g, '').replace(/_/g, ' ');
      if (name === 'custom 1') {
        name = 'Specialized';
      }
      if (name === 'custom 3') {
        name = 'Phone Number';
      }
      if (name === 'passwordConfirm') {
        name = 'confirm password';
      }
      emptyFields.push(name);
    }
  });

  Array.from(selectArray).forEach((select) => {
    if (select.selectedIndex === 0) {
      const name = select.name.replace(/reg_/g, '').replace(/_/g, ' ');
      emptyFields.push(name);
    }
  });

  return emptyFields;
};

const checkInputValidity = () => {
  const inputs = document.getElementsByTagName('input');
  const inputArray = [];
  const selects = document.getElementsByTagName('select');
  const selectArray = [];

  Array.from(inputs).forEach((input) => {
    inputArray.push(input);
  });

  Array.from(selects).forEach((select) => {
    selectArray.push(select);
  });

  return (
    inputArray.every((val) => {
      return val.checkValidity() === true;
    }) &&
    selectArray.every((val) => {
      return val.selectedIndex !== 0;
    })
  );
};

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

let lang = localStorage.getItem('lang');
if (lang) {
  lang = JSON.parse(lang);
  lang = lang.rawData;
} else {
  lang = '';
}

export default class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userInput: {
        email: getLastEmail(),
        registration_code: '',
        reg_email: '',
        reg_password: '',
        reg_confirmPassword: '',
        reg_first_name: '',
        reg_last_name: '',
        reg_zip_code: '',
        reg_country: '',
        reg_state: '',
        reg_city: '',
        reg_agency_name: '',
        reg_agency_affiliation: '',
        reg_host_agency_name: '',
        reg_agency_business: '',
        reg_how_discovered_kla: '',
        reg_how_discovered_kla_tradeshow_detail: '',
        marketing_opt_in: false,
        opt_in_marketing: false,
      },
      animation: {
        loadingAnim: false,
        loadingAnimRegister: false,
        loadingAnimForgot: false,
      },
      message: '',
      redirect: '',
      admission_message: '',
      verified_message: '',
      resend_link: '',
      userExists: null,
      clientId: '',
      programUrl: '',
    };

    document.body.classList.add('no-scroll');

    this.changeHandler = this.changeHandler.bind(this);
    this.fieldChangeHandler = this.fieldChangeHandler.bind(this);
    this.backHandler = this.backHandler.bind(this);
    this.setAnim = this.setAnim.bind(this);
    this.userExistsHandler = this.userExistsHandler.bind(this);
    this.magicLinkHandler = this.magicLinkHandler.bind(this);
    this.enableMarketing = this.enableMarketing.bind(this);
    this.changeItemHandler = this.changeItemHandler.bind(this);
  }

  async componentDidMount() {
    this.getAppInfo();
    await this.checkRedirect();
  }

  getAppInfo() {
    StorageHandler.load(storageKeys.appInfo).then((appInfo) => {
      if (appInfo) {
        const { clientId, programUrl } = appInfo;
        this.setState({ clientId, programUrl });
      }
    });
  }

  setAnim(type, value) {
    const { animation } = this.state;
    animation[type] = value;
    this.setState({ animation });
  }

  setMessage(message) {
    this.setState({ message });
    const el = document.querySelector('.form__message');
    el.style.opacity = 1;
    el.style.color = 'black';
  }

  changeItemHandler(event, name) {
    this.setState((prevState) => {
      return { userInput: { ...prevState.userInput, [name]: event } };
    });
  }

  async checkRedirect() {
    const { path } = this.props;
    const userExists = await StorageHandler.exists(storageKeys.user);
    const openPaths = [
      '/login/quick-register',
      '/login/register-mobile',
      '/login/quick-register-mobile',
      '/register-mobile',
      '//register-mobile',
    ];

    if (openPaths.includes(window.location.pathname)) {
      this.loadUserData();
      return;
    }

    // Handle language codes - default to US for English locales
    let countryCode = 'US'; // Default to US

    if (lang && lang.code) {
      const langCodeUpper = lang.code.toUpperCase();
      // Exception: en-GB should use GB, not US
      if (langCodeUpper === 'EN-GB') {
        countryCode = 'GB';
      } else if (langCodeUpper === 'EN' || langCodeUpper.startsWith('EN-')) {
        // If it's "EN" or starts with "EN-" (but not EN-GB), use US
        countryCode = 'US';
      } else {
        // Otherwise, try to extract country code or use the code as-is
        // If it contains a dash, take the part after the dash (e.g., "fr-FR" -> "FR")
        if (langCodeUpper.includes('-')) {
          countryCode = langCodeUpper.split('-')[1] || langCodeUpper;
        } else {
          countryCode = langCodeUpper;
        }
      }
    }

    this.setState({
      userInput: {
        ...this.state.userInput,
        reg_country: countryCode,
      },
    });
    if (countryCode === 'US') {
      this.setState({
        userInput: {
          ...this.state.userInput,
          marketing_opt_in: true,
          opt_in_marketing: true,
        },
      });
    }

    if (path !== '/logout' && userExists) {
      this.setState({ redirect: '/main' });
    } else {
      sessionManager.end();
      StorageHandler.remove(storageKeys.sessionId);
      StorageHandler.removeKeys(userKeys);
      StorageHandler.remove(storageKeys.accessToken);
      StorageHandler.remove(storageKeys.refreshToken);
      StorageHandler.remove(storageKeys.fastTrackData);
      setLastEmail('');
      if (path !== '/login') {
        this.setState({ redirect: '/login' });
      }
    }
  }

  loadUserData() {
    // Load data from local storage
    // TODO all fields
    StorageHandler.load(storageKeys.user).then((user) => {
      const country = user.country;
      // US: always show marketing on at registration (ignore API opt-out). Non-US: use API values.
      let marketingOptIn = user.marketing_opt_in;
      let optInMarketing = user.opt_in_marketing ?? user.marketing_opt_in;
      if (country === 'US') {
        marketingOptIn = true;
        optInMarketing = true;
      }
      this.setState((prevState) => {
        return {
          userInput: {
            ...prevState.userInput,
            email: user.email,
            reg_email: user.email,
            reg_first_name: user.first_name,
            reg_last_name: user.last_name,
            reg_agency_name: user.agency_name,
            reg_city: user.city,
            reg_country: user.country,
            reg_state: user.state,
            reg_zip_code: user.zip_code,
            reg_agency_affiliation: user.agency_affiliation,
            reg_host_agency_name: user.host_agency_name,
            reg_agency_business: user.agency_business,
            marketing_opt_in: marketingOptIn,
            opt_in_marketing: optInMarketing,
          },
        };
      });
    });
  }

  backHandler() {
    document.querySelector('.form__message').style.opacity = 0;
    this.setAnim('loadingAnim', false);
  }

  userExistsHandler(boolean) {
    this.setState({ userExists: boolean });
  }

  fieldChangeHandler(name, value) {
    if (name === 'email') {
      setLastEmail(value);
    }

    this.setState((prevState) => {
      const prev = prevState.userInput;
      let next = { ...prev, [name]: value };

      if (name === 'reg_country') {
        if (next.reg_country === 'US') {
          next = { ...next, marketing_opt_in: true, opt_in_marketing: true };
        } else {
          next = { ...next, marketing_opt_in: false, opt_in_marketing: false };
        }
      }

      return { userInput: next };
    });
  }

  changeHandler(event) {
    const value = event.target.value || event.target.checked;
    this.fieldChangeHandler(event.target.name, value);
  }

  enableMarketing() {
    this.setState((prevState) => {
      return { userInput: { ...prevState.userInput, opt_in_marketing: true } };
    });
  }

  async resendHandler() {
    await APIHandler.resendVerificationLink(this.state.resend_link).then((res) => {
      if (res.success) {
        toast.info(res.message, {
          position: 'top-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        this.setState({ resend_link: '' });
      }
    });
  }

  magicLinkHandler(event) {
    const submit = event.target;
    submit.disabled = true;
    event.preventDefault();
    const { clientId, programUrl } = this.state;
    const { email } = this.state.userInput;
    this.setAnim('loadingAnimForgot', true);
    const language = lang.langFile || 'en';
    APIHandler.magicLink(email, language, clientId, programUrl).then((res) => {
      if (res.success && res.success === true) {
        this.setAnim('loadingAnimForgot', false);
        submit.disabled = false;
        toast.info(
          i18n.translate('loginScreen.version2.toastMessage.magicLinkSuccess', {
            email,
          }),
          {
            position: 'top-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          },
        );
      } else if (res.response.status === 400) {
        this.setAnim('loadingAnimForgot', false);
        submit.disabled = false;
        toast.error(i18n.translate('loginScreen.version2.toastMessage.magicLinkErrorWait'), {
          position: 'top-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        this.setAnim('loadingAnimForgot', false);
        submit.disabled = false;
        toast.error(i18n.translate('loginScreen.version2.toastMessage.emailNotFoundError'), {
          position: 'top-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        window.setTimeout(() => {
          window.location.href = '/login/register';
        }, 2000);
      }
      window.setTimeout(() => {
        window.location.href = '/login';
      }, 10000);
    });
  }

  render() {
    const { animation, message, redirect, userInput, userExists } = this.state;

    const { pathname } = window.location;

    return (
      <form className="login__form">
        {pathname === '/login' && (
          <Email
            change={this.changeHandler}
            checkInputValidity={checkInputValidity}
            loadingAnim={animation.loadingAnim}
            setAnim={this.setAnim}
            userExists={userExists}
            userExistsHandler={this.userExistsHandler}
            userInput={userInput}
          />
        )}

        {pathname === '/login/magic-link' && (
          <MagicLink
            back={this.backHandler}
            defaultVal={userInput.email}
            submit={this.magicLinkHandler}
            change={this.changeHandler}
            loadingAnimRegister={animation.loadingAnimForgot}
          />
        )}

        {pathname === '/login/forgot' && (
          <Forgot
            back={this.backHandler}
            change={this.changeHandler}
            defaultVal={userInput.email}
            loadingAnimRegister={animation.loadingAnimForgot}
            setAnim={this.setAnim}
          />
        )}

        {(pathname === '/login/register' ||
          pathname === '/login/register-mobile' ||
          pathname === '//register-mobile' ||
          pathname === '/register-mobile') && (
          <Register
            passwordField
            back={this.backHandler}
            change={this.changeHandler}
            updateFormField={this.fieldChangeHandler}
            checkInputValidity={checkInputValidity}
            checkInputValidityFields={checkInputValidityFields}
            loadingAnimRegister={animation.loadingAnimRegister}
            setAnim={this.setAnim}
            userInput={userInput}
            country={userInput.reg_country}
            changeItem={this.changeItemHandler}
            enableMarketing={this.enableMarketing}
            defaultVal={userInput.email}
          />
        )}

        {(pathname === '/login/quick-register' || pathname === '/login/quick-register-mobile') && (
          <Register
            passwordField={false}
            back={this.backHandler}
            change={this.changeHandler}
            updateFormField={this.fieldChangeHandler}
            checkInputValidity={checkInputValidity}
            checkInputValidityFields={checkInputValidityFields}
            loadingAnimRegister={animation.loadingAnimRegister}
            setAnim={this.setAnim}
            userInput={userInput}
            country={userInput.reg_country}
            changeItem={this.changeItemHandler}
            enableMarketing={this.enableMarketing}
            defaultVal={userInput.email}
          />
        )}

        <h3 className="form__message">{message}</h3>

        {redirect.length > 0 && <Redirect push to={redirect} />}
        <p className="legal">
          {i18n.translate('loginScreen.tAndC.agree')}
          <span
            role="button"
            tabIndex={-1}
            data-fancybox="privacy"
            data-type="iframe"
            href="https://travpromobile.com/privacy_policy.html"
          >
            {i18n.translate('loginScreen.tAndC.privacyPolicy')}
          </span>
          {i18n.translate('loginScreen.tAndC.and')}
          <span
            role="button"
            tabIndex={0}
            data-fancybox="terms"
            data-type="iframe"
            href="https://travpromobile.com/terms_of_use.html"
          >
            {i18n.translate('loginScreen.tAndC.termsConditions')}
          </span>
          {'.'}
        </p>
        <SweetAlert
          html
          title=""
          onConfirm={() => {
            this.setState({ admission_message: '' });
          }}
          show={!!this.state.admission_message}
          confirmButtonText="Ok"
          text={this.state.admission_message}
        />
        <SweetAlert
          html
          title="Email not Verified:"
          onConfirm={() => {
            this.setState({ verified_message: '' });
          }}
          onCancel={() => {
            this.setState({ verified_message: '' });
            this.resendHandler();
          }}
          show={!!this.state.verified_message}
          confirmButtonText="Ok"
          cancelButtonText="Resend email"
          showCancelButton
          text={this.state.verified_message}
        />
        <ToastContainer draggablePercent={70} />
      </form>
    );
  }
}

LoginForm.propTypes = {
  path: PropTypes.string,
};

LoginForm.defaultProps = {
  path: '/login',
};
